module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_a-function.js
// module id = 823
// module chunks = 0